export default "__VITE_ASSET__12756b9b__"